/**
 * Shared constants for study schema settings components.
 * Extracted to avoid circular dependencies between StudySchemaMetadataSettings
 * and StudySchemaIdGenerationSettings.
 */

// Keep in sync with benchling.studies.domain.constants.py
export const AUTO_GENERATE_ID_LABEL = 'Autogenerate ID with a specified prefix';
export const MANUAL_ID_LABEL = 'Manually specify ID at creation time';
export const CHANGE_ID_GENERATION_MODE_MESSAGE =
  'Changing how IDs are set only affects studies created from now on; existing studies keep their IDs. ' +
  'When switching to autogenerated IDs, numbering continues from the highest existing ID that uses the prefix.';

// The settings rows lay out as a three-column grid: each column is SETTINGS_GRID_COLUMN_WIDTH_PERCENT
// of the row width, separated by SETTINGS_GRID_COLUMN_GAP_PERCENT gaps. These are the single source of
// truth for the grid, so grouped controls that span multiple columns (see StudySchemaIdGenerationSettings)
// can align to the same grid instead of re-deriving the math with hand-computed percentages.
export const SETTINGS_GRID_COLUMN_WIDTH_PERCENT = 30;
export const SETTINGS_GRID_COLUMN_GAP_PERCENT = 5;
